import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex justify-between gap-0 w-full !bg-surface-0" };
const _hoisted_2 = { class: "flex flex-col justify-center gap-0 w-full min-w-[15.625rem]" };
const _hoisted_3 = { class: "text-surface-700 text-sm font-semibold ellipsis truncate max-w-[250px]" };
const _hoisted_4 = { class: "text-surface-500 text-xs font-normal" };
const _hoisted_5 = { class: "flex flex-col items-end justify-center w-full min-w-[5.313rem] font-semibold text-surface-900 text-xs gap-3" };
const _hoisted_6 = { class: "text-orange-500 dark:text-orange-500" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'TimeOffMainParentCell',
    props: {
        node: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_RouterLink = _resolveComponent("RouterLink");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_RouterLink, {
                            to: `/user/${__props.node.userData.id}#general`
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(__props.node.userData.name), 1)
                            ]),
                            _: 1
                        }, 8, ["to"])
                    ]),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(__props.node.userData.title), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$tf("timeManagementOverview.timeOff|Szabadság")), 1)
                ])
            ]));
        };
    }
});
